export var RequestMethod;
(function (RequestMethod) {
    RequestMethod["CLI"] = "CLI";
    RequestMethod["CLI_CI"] = "CLI_CI";
    RequestMethod["WEB_APP"] = "WEB_APP";
    RequestMethod["HEADLESS_BROWSER"] = "HEADLESS_BROWSER";
    RequestMethod["UNKNOWN"] = "UNKNOWN";
})(RequestMethod || (RequestMethod = {}));
export const isRequestMethod = (value) => !!value && Object.values(RequestMethod).includes(value);
//# sourceMappingURL=api.js.map